import { useTranslation } from "react-i18next";
import type { ErrorLineLink } from "@/components/forms/errorHandling/errorMessageLines";

const BSI_SECURE_PASSWORD_GUIDE_URL_DE =
  "https://www.bsi.bund.de/DE/Themen/Verbraucherinnen-und-Verbraucher/Informationen-und-Empfehlungen/Cyber-Sicherheitsempfehlungen/Accountschutz/Sichere-Passwoerter-erstellen/sichere-passwoerter-erstellen_node.html";
const BSI_SECURE_PASSWORD_GUIDE_URL_EN =
  "https://www.bsi.bund.de/EN/Themen/Verbraucherinnen-und-Verbraucher/Informationen-und-Empfehlungen/Cyber-Sicherheitsempfehlungen/Accountschutz/Sichere-Passwoerter-erstellen/sichere-passwoerter-erstellen_node.html";

export const useSecurePasswordGuideLink = (): ErrorLineLink => {
  const { t, i18n } = useTranslation();
  return {
    label: t("secure_password_guide"),
    to:
      i18n.language === "en"
        ? BSI_SECURE_PASSWORD_GUIDE_URL_EN
        : BSI_SECURE_PASSWORD_GUIDE_URL_DE,
  };
};
